import { render } from "./MdModal.vue?vue&type=template&id=c2338b02&scoped=true&ts=true"
import script from "./MdModal.vue?vue&type=script&lang=ts"
export * from "./MdModal.vue?vue&type=script&lang=ts"

import "./MdModal.vue?vue&type=style&index=0&id=c2338b02&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2338b02"]])

export default __exports__